import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@skill skill-id, Термин на русском}
export const SkillPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'glossaryItem'} params={{id: 'skill'}} title={title} className={linkClass('skill')}>
			{title}
		</Link>
	);
};
